import ViewBase from "../../../../framework/core/mvvm/view_base";
import ModuleManager from "../../../../framework/core/module_manager";
import EventManager from "../../../../manager/event_manager";
import ChatRecordItem from "./chatrecorditem"
import ChatRecordData from "./chatrecorddata";
import TableChatData from "./tablechat_data";
import ModelData, { IUserData } from "../../../public/model_data";
import Utility from "../../../../utility/utility";

const { ccclass, property } = cc._decorator;

@ccclass
export default class ChatInfoView extends ViewBase {
    

    @property(cc.Button)
    btnClose: cc.Button = null;
   
   

    @property([cc.Button])
    emojiBtnList: cc.Button[] = []

    showNode:cc.Node=null

    @property(cc.Label)
    playerNameTxt:cc.Label = null;

    @property(cc.Label)
    baseInfoID:cc.Label = null;

    @property(cc.Sprite)
    baseInfoSprite:cc.Sprite = null;

    @property(cc.Label)
    mangguoMoney:cc.Label = null;

    @property(cc.Label)
    choumaMoney:cc.Label = null;

    @property(cc.Toggle)
    toggleMale: cc.Toggle = null;

    @property(cc.Toggle)
    toggleFemale: cc.Toggle = null;

    @property(cc.Label)
    maxVectoryCM:cc.Label = null;

    @property(cc.Label)
    maxVectoryMG:cc.Label = null;

    @property(cc.Label)
    historyMaxCM:cc.Label = null;

    @property(cc.Label)
    historyMaxMG:cc.Label = null;

    @property(cc.Label)
    gamescm:cc.Label = null;
    @property(cc.Label)
    gamesmg:cc.Label = null;

    @property(cc.Node)
    chipNode:cc.Node = null;

    @property(cc.Node)
    goldNode:cc.Node = null;

    playerId=0

    

    onInit() {
        this.node.position=new cc.Vec2(0,0)
    }

    onShow(arg0) 
    {
        super.onShow(arg0)
        this.node.position=new cc.Vec2(0,0)
        
        this.showChipGold()
    }
    showChipGold() {
        
        this.chipNode.active=ModelData.instance.showChipCurrency
        this.goldNode.active=ModelData.instance.showGoldCurrency
        if(!ModelData.instance.showChipCurrency && ModelData.instance.showGoldCurrency)
        {
            this.goldNode.position=this.chipNode.position
        }
    }
    
    refreshPlayerMoney(gold:number,chip:number){
        let _gold = this.currencyFormatting(gold);
        let _chip = this.currencyFormatting(chip);
        this.mangguoMoney.string = Utility.currencyFormatting(_gold);
        this.choumaMoney.string = Utility.currencyFormatting(_chip);
    }

    currencyFormatting(money:number){
        return Math.floor(money * 1000 / 10) / 100
    }
    formatGold(money:number){
        if (money <= 0.001) {
            return '0';
        }
        let _money = this.currencyFormatting(money);
        return Utility.currencyFormatting(_money);
    }
    updateJS(mg:number,cm:number){
        this.gamescm.string = cm.toString();
        this.gamesmg.string = mg.toString();
    }
    //最高获胜
    updateMaxVectory(mg:number,cm:number){
        this.maxVectoryCM.string = this.formatGold(cm);
        this.maxVectoryMG.string = this.formatGold(mg);
    }

    //最高历史记录
    updateMaxHistoryGold(mg:number,cm:number){
        this.historyMaxCM.string = this.formatGold(cm);
        this.historyMaxMG.string = this.formatGold(mg);
    }
    refreshPlayerInfo(roleData: IUserData)
    {
        //this.playerSprite = roleData.avatarSprite
        //this.refreshPlayerIcon(roleData.avatarSprite);
        this.refreshPlayerBaseInfoIcon(roleData.avatarSprite)

        let idstr = "ID:" + roleData.id.toString();
        //this.playerID.string = idstr;
        this.baseInfoID.string = idstr;

        this.playerNameTxt.string = roleData.name
        //this.eidtorBox.string = roleData.name
    }
    // refreshPlayerIcon(spriteFrame: cc.SpriteFrame)
    // {
    //     if (!spriteFrame) {
    //         return;
    //     }
    //     this.playerIcon.spriteFrame = spriteFrame;
    // }

    refreshPlayerBaseInfoIcon(spriteFrame: cc.SpriteFrame){
        if (!spriteFrame) {
            return;
        }
        this.baseInfoSprite.spriteFrame = spriteFrame;
    }
}